module.exports = __webpack_public_path__ + "static/ecochin-18130b29775d2133b17b2d25bba1bf7b.png";